import * as React from 'react';
import { useEffect } from 'react';

import {ISolution} from "../../data/SolutionDataSource";
import {IBundle} from "../../data/BundleData";
import {SecondaryBar} from "../widgets/SecondaryBar";

import './OnSiteHealthFair.pcss';
import {PrimaryLayout} from "../widgets/PrimaryLayout";
import {SolutionOverview} from "../solution/SolutionOverview";
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {FeedItemEntity} from "../../data/entities/FeedItemEntity";
import {SolutionBundleCard} from "./SolutionBundleCard";
import * as moment from "moment/moment";
import {Photo} from "../Photo";
import {PhotoRendered} from "../PhotoRendered";
import {UIState} from "data/UIState";
import {BottomBackButton} from "components/widgets/BottomBackButton";

interface Props {
  dashboardSolution:DashboardSolution;
  solution:ISolution;
  onSelectBundle:(bundle:IBundle)=>void;
  onBack:()=>void;
  feedItems:FeedItemEntity[];
  solutionCurrentPoints:number;

}

export const OnSiteHealthFair = (props:Props) => {

    useEffect(() => {
        //console.log('OnSiteHealthFair rendered');
        const collapsedNotificationTarget = UIState.collapsedNotificationTarget;
        if(collapsedNotificationTarget && !collapsedNotificationTarget.notificationLinkUsed) {
          //console.log('OnSiteHealthFair collapsedNotificationTarget', collapsedNotificationTarget);
          setTimeout(()=>{
            //console.log('OnSiteHealthFair setTimeout');

            // First look for a post that is visible in the feed
            if(collapsedNotificationTarget.bundleId) {
              //console.log('OnSiteHealthFair bundleId');

              if(props.solution.solutionBundles) {
                //console.log('OnSiteHealthFair solutionBundles');

                for(let i=0;i<props.solution.solutionBundles.length;i++) {
                  if(props.solution.solutionBundles[i].bundleId===collapsedNotificationTarget.bundleId) {
                    //console.log('OnSiteHealthFair bundle found');

                    // Get the solution bundle
                    const bundleIdx = props.solution.bundles.findIndex(b => b._id === props.solution.solutionBundles[i].bundleId);
                    if (-1 !== bundleIdx) {
                      props.onSelectBundle(props.solution.bundles[bundleIdx]);
                      // we will need the collapsedNotificationTarget to open the post if it exists
                      // UIState.collapsedNotificationTarget = null;
                      collapsedNotificationTarget.markNotificationLinkUsed();
                      return;
                    }
                  }
                }
              }
            }
          }, 1); // setTimeout

        }
      },
      []
    ); //empty array makes sure that this effect only runs once.


      const allSolutionFeedItemsWithPointsAwarded =  props.feedItems.filter(feedItem=>feedItem.pointsAwarded);
      allSolutionFeedItemsWithPointsAwarded.sort((a,b)=> (moment(a.pointsAwardedDate).isBefore(moment(b.pointsAwardedDate)) ? 1 : -1 ));

      const hasPrizes = props.solution.prizes && props.solution.prizes.length>0;
      const hasPoints = allSolutionFeedItemsWithPointsAwarded.length>0;



  return (
      <PrimaryLayout className={"onsite-health-fair"}>
        <SecondaryBar title={props.solution.name} subTitle={props.solution.subTitle} buttonAction={props.onBack} />
        <div className={"pl-inner"}>
          <div className={"topper"}>
            <SolutionOverview dashboardSolution={props.dashboardSolution} solutionCurrentPoints={props.solutionCurrentPoints} />
          </div>
          <div className={"ohf-container"}>
            <ul className={"reset"}>
              {props.solution.solutionBundles.map(solutionBundle=>{

                // find the associated bundle
                const bundleIdx = props.solution.bundles.findIndex(b=>b._id===solutionBundle.bundleId);
                if(-1===bundleIdx) {
                  return null;
                }

                const bundle = props.solution.bundles[bundleIdx];

                const feedItemsWithPossiblePoints = props.feedItems.filter(feedItem=>feedItem.bundleId===bundle._id && feedItem._post && feedItem._post.pointValue>0);
                let maxPoints = feedItemsWithPossiblePoints.reduce((accumulator, feedItem) => accumulator + feedItem._post.pointValue, 0);
                if(solutionBundle.checkInPointValue>0) {
                  maxPoints += solutionBundle.checkInPointValue;
                }
                if(bundle.conversationPost && bundle.conversationPost.pointValue>0) {
                  const idx = feedItemsWithPossiblePoints.findIndex(fi=>(fi._post && fi._post._id===bundle.conversationPost._id));
                  if(-1===idx) {
                    maxPoints += bundle.conversationPost.pointValue;
                  }
                }


                const feedItemsWithPointsAwarded =  props.feedItems.filter(feedItem=>feedItem.bundleId===bundle._id && feedItem.pointsAwarded);
                const currentPoints = feedItemsWithPointsAwarded.reduce((accumulator, feedItem) => accumulator + feedItem.pointsAwarded, 0);

                // if(bundle.fullName==='Eat This, Not That') {
                //   console.log("maxPoints " + maxPoints);
                //   console.log("currentPoints " + currentPoints);
                //   console.log("props.solutionCurrentPoints " + props.solutionCurrentPoints);
                // }

                return (
                    <li key={bundle._id}>
                      <SolutionBundleCard
                          solutionBundle={solutionBundle}
                          bundle={bundle}
                          onClick={props.onSelectBundle}
                          bundleMaxPoints={maxPoints}
                          bundleCurrentPoints={currentPoints}
                          solutionCurrentPoints={props.solutionCurrentPoints}
                      />
                    </li>
                );
              })}
            </ul>
          </div>


          {hasPrizes || hasPoints &&
            <div className={"ohf-footer"}>

              {hasPrizes && <>
                <h2>Prizes</h2>
                <div className={"ohff-prizes"}>
                  {props.solution.prizes.map(prize=> {
                    const prizeTitle = prize.prizeTitle ? prize.prizeTitle +": "+ prize.what : prize.what;
                    return (
                        <div className={"ohff-prize"}>
                          <div className={"ohffp-photo"}><img src={prize.image} /></div>
                          <div className={"ohffp-content"}>
                            <h3>{prizeTitle}</h3>
                            <h4>{prize.how}</h4>
                            <h5>{prize.when}</h5>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
              </>}

              {hasPoints && <>
                <h2 className={"points-title"}>Your points earned</h2>
                <ul className={"points-list"}>
                {allSolutionFeedItemsWithPointsAwarded.map(feedItem=> {
                  const iconPhoto = new Photo( feedItem._post ? '/img/noun_video_quiz.svg' : (feedItem.icon?feedItem.icon:null) );
                  return (
                    <li key={feedItem._id} className={'points-earned'}>
                      <PhotoRendered photo={iconPhoto} />
                      <h3>{feedItem._post ? feedItem._post.title : feedItem.content}</h3>
                      <span aria-hidden>+</span>
                      <div className={"pe-points"} aria-label={`${feedItem.pointsAwarded} point${feedItem.pointsAwarded==1?"":"s"}`}>{feedItem.pointsAwarded}</div>
                    </li>
                  );
                }
                )}
                </ul>
              </>}

            </div>
          }


        </div>
        <BottomBackButton backLabel={"Back to Dashboard"} onClick={props.onBack} style={{ marginTop: '48px' }} />
      </PrimaryLayout>
    );
}
;

